(() => {
  const initialize = scope => {
    scope.querySelectorAll('.kj-mobile-nav').forEach(nav => {
      if (nav.dataset.kjReady) return;
      nav.dataset.kjReady = 'true';
      nav.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { nav.open = false; }));
    });
    scope.querySelectorAll('[data-kj-product]').forEach(root => {
      if (root.dataset.kjReady) return;
      root.dataset.kjReady = 'true';
      const variants = JSON.parse(root.querySelector('[data-kj-variants]').textContent);
      const form = root.querySelector('form');
      const select = root.querySelector('[data-kj-variant]');
      const button = root.querySelector('[data-kj-submit]');
      const error = root.querySelector('[data-kj-error]');
      const sizeInputs = [...root.querySelectorAll('[data-kj-size]')];
      const offerInputs = [...root.querySelectorAll('[data-kj-offer]')];
      const enhanced = root.querySelector('.kj-enhanced');
      const sticky = root.querySelector('[data-kj-sticky]');
      let selected = variants.find(v => String(v.id) === select.value);
      let busy = false;
      const chosenSize = () => sizeInputs.find(i => i.checked)?.value;
      const chosenOffer = () => offerInputs.find(i => i.checked)?.value;
      const find = offer => variants.find(v => v.title === `${chosenSize()} — ${offer}`);
      const resolve = () => {
        offerInputs.forEach(input => {
          const variant = find(input.value);
          input.disabled = !variant?.available;
          input.closest('label').querySelector('[data-kj-offer-price]').textContent = variant?.price || root.dataset.kjUnavailable;
          const card = input.closest('label');
          const saving = card.querySelector('[data-kj-offer-saving]');
          const comparison = card.querySelector('[data-kj-offer-comparison]');
          if (saving && comparison) {
            saving.hidden = comparison.hidden = !(variant?.saving > 0);
            saving.textContent = variant?.savingLabel || '';
            comparison.querySelector('[data-kj-separate-price]').textContent = variant?.separateLabel || '';
          }
        });
        let offer = offerInputs.find(i => i.checked);
        if (!offer || offer.disabled) {
          const available = offerInputs.find(i => !i.disabled);
          if (available) { available.checked = true; offer = available; }
        }
        selected = offer ? find(offer.value) : undefined;
        if (selected) select.value = String(selected.id);
        button.disabled = busy || !selected?.available;
        button.textContent = selected?.available ? `${root.dataset.kjAdd} — ${selected.price} →` : root.dataset.kjUnavailable;
        root.querySelector('[data-kj-sticky-price]').textContent = selected?.price || root.dataset.kjUnavailable;
        const unlocked = !!selected?.title.includes('Complete Kit');
        root.querySelector('[data-kj-kit]').dataset.kjLocked = String(!unlocked);
        root.querySelector('[data-kj-gift-status]').textContent = unlocked ? root.dataset.kjGiftsIncluded : root.dataset.kjGiftsLocked;
        root.querySelectorAll('[data-kj-gift-badge]').forEach(badge => { badge.textContent = unlocked ? root.dataset.kjGiftFree : root.dataset.kjGiftLocked; });
      };
      const enhancedValid = sizeInputs.some(i => i.checked) && offerInputs.some(i => i.checked) && variants.some(v => v.title.includes(' — '));
      if (enhancedValid) {
        enhanced.hidden = false;
        root.querySelector('.kj-fallback').hidden = true;
        sizeInputs.forEach(input => input.addEventListener('change', resolve));
        offerInputs.forEach(input => input.addEventListener('change', resolve));
        resolve();
      } else {
        select.addEventListener('change', () => {
          selected = variants.find(v => String(v.id) === select.value);
          button.disabled = !selected?.available;
          button.textContent = selected?.available ? `${root.dataset.kjAdd} — ${selected.price} →` : root.dataset.kjUnavailable;
          root.querySelector('[data-kj-sticky-price]').textContent = selected?.price || root.dataset.kjUnavailable;
        });
        root.querySelector('.kj-fallback').id = 'KeelJourneyBuy';
      }
      root.querySelectorAll('[data-kj-image]').forEach(thumb => thumb.addEventListener('click', () => {
        const image = root.querySelector('.kj-hero-image');
        if (!image) return;
        image.removeAttribute('srcset');
        image.src = thumb.dataset.kjImage;
        image.alt = thumb.dataset.kjAlt;
        root.querySelector('.kj-main-image').dataset.kjScene = thumb.dataset.kjScene || 'photo';
        const thumbnails = [...root.querySelectorAll('[data-kj-image]')];
        const counter = root.querySelector('[data-kj-image-counter]');
        if (counter) counter.textContent = String(thumbnails.indexOf(thumb) + 1).padStart(2, '0') + ' / ' + String(thumbnails.length).padStart(2, '0');
        root.querySelectorAll('[data-kj-image]').forEach(t => t.setAttribute('aria-pressed', String(t === thumb)));
      }));
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, { threshold: 0.05 }).observe(form);
      }
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !selected?.available) return;
        error.hidden = true;
        const kit = selected.title.includes('Complete Kit');
        const giftIds = root.dataset.kjGifts.split(',').filter(Boolean).map(Number);
        if (kit && (giftIds.length !== 3 || giftIds.some(id => !id))) {
          error.textContent = root.dataset.kjKitError; error.hidden = false; return;
        }
        const count = selected.title.includes('Two pouches') ? '2' : '1';
        const properties = { 'Joint Daily pouches': count };
        if (chosenSize()) properties['Dog size'] = chosenSize();
        const items = [{ id: selected.id, quantity: 1, properties }];
        if (kit) giftIds.forEach(id => items.push({ id, quantity: 1 }));
        busy = true; button.disabled = true; button.textContent = root.dataset.kjAdding;
        try {
          if (window.keelCartReady) await window.keelCartReady;
          const drawer = document.querySelector('cart-drawer');
          const payload = { items };
          const sections = drawer?.getSectionsToRender().map(section => section.id) || [];
          if (drawer) {
            payload.sections = sections;
            payload.sections_url = window.location.pathname;
            drawer.setActiveElement(button);
          }
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || root.dataset.kjError);
          if (drawer && sections.every(id => typeof result.sections?.[id] === 'string')) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(result);
          } else {
            window.location.assign(root.dataset.kjCart);
          }
        } catch (e) {
          error.textContent = e.message || root.dataset.kjError; error.hidden = false;
        } finally {
          busy = false;
          if (enhancedValid) resolve();
          else { button.disabled = !selected?.available; button.textContent = `${root.dataset.kjAdd} — ${selected.price} →`; }
        }
      });
    });
    scope.querySelectorAll('[data-kj-tabs]').forEach(root => {
      if (root.dataset.kjReady) return;
      root.dataset.kjReady = 'true';
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const panels = [...root.querySelectorAll('[role="tabpanel"]')];
      const activate = index => {
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index; });
      };
      activate(0);
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault(); activate(next); tabs[next].focus();
        });
      });
    });
  };
  const start = () => initialize(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('.kj-tabpanel');
    if (panel) document.getElementById(panel.getAttribute('aria-labelledby'))?.click();
  });
})();



